import {lazy} from "react";

export const ReportTrackerOutagesLazy = lazy(() => import('./ReportTrackerOutages'))
